import type { FastifyPluginAsync } from 'fastify'
import type { Firestore } from 'firebase-admin/firestore'
import type { RedisClient } from '../../core/redis/client.js'
import { DashboardController } from './dashboard.controller.js'
import { ProfileService } from '../profile/profile.service.js'
import { GamificationService } from '../gamification/gamification.service.js'
import { QuestService } from '../gamification/quest.service.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'

export const dashboardModule: FastifyPluginAsync<{
  firestore: Firestore
  redis: RedisClient
}> = async (fastify, opts) => {
  const { firestore, redis } = opts

  // Initialize services
  const profileService = new ProfileService(firestore)
  const gamificationService = new GamificationService(firestore, redis)
  const questService = new QuestService(firestore, redis)

  const controller = new DashboardController(
    profileService,
    gamificationService,
    questService
  )

  // Add auth middleware
  fastify.addHook('onRequest', authMiddleware)

  // Routes
  fastify.get('/init', controller.init.bind(controller))
}
